<script setup>
import { useRoute, useRouter } from "vue-router";
import { ref } from "vue";
import SidenavItem from "./SidenavItem.vue";

const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};

// Obtener el rol del usuario
const user = JSON.parse(localStorage.getItem("user"));
const userRole = user ? user.tipo_cliente : null;

const router = useRouter();
const showModal = ref(false); // Modal visible

const CerrarSesion = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("user");
  router.push({ name: "Login" });
};
</script>

<template>
  <div class="collapse navbar-collapse w-auto h-auto h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">
      <!-- Categorías -->
      <li v-if="userRole === 'SuperAdmin' || userRole === 'Administrador' || userRole === 'Docente'" class="nav-item">
        <sidenav-item
          to="/cliente-categorias"
          :class="getRoute() === 'cliente-categorias' ? 'active' : ''"
          :navText="'Categorías'"
        >
          <template v-slot:icon>
            <i class="bi bi-list text-custom fs-5 text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <!-- Usuarios -->
      <li v-if="userRole === 'SuperAdmin' || userRole === 'Administrador' || userRole === 'Docente'" class="nav-item">
        <sidenav-item
          to="/cliente-usuarios"
          :class="getRoute() === 'cliente-usuarios' ? 'active' : ''"
          :navText="'Usuarios'"
        >
          <template v-slot:icon>
            <i class="bi bi-people text-custom fs-5 text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <!-- Cursos -->
      <li v-if="userRole === 'SuperAdmin' || userRole === 'Administrador' || userRole === 'Docente'" class="nav-item">
        <sidenav-item
          to="/cliente-cursos"
          :class="getRoute() === 'cliente-cursos' ? 'active' : ''"
          :navText="'Cursos'"
        >
          <template v-slot:icon>
            <i class="bi bi-journal-bookmark text-custom fs-3 text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <!-- Certificados -->
      <li v-if="userRole === 'SuperAdmin' || userRole === 'Administrador'" class="nav-item">
        <sidenav-item
          to="/cliente-certificado"
          :class="getRoute() === 'cliente-certificado' ? 'active' : ''"
          :navText="'Certificados'"
        >
          <template v-slot:icon>
            <i class="bi bi-award text-custom fs-5 text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <!-- Evaluaciones -->
      <li v-if="userRole === 'SuperAdmin' || userRole === 'Administrador' || userRole === 'Docente'" class="nav-item">
        <sidenav-item
          to="/cliente-evaluaciones"
          :class="getRoute() === 'cliente-evaluaciones' ? 'active' : ''"
          :navText="'Evaluaciones'"
        >
          <template v-slot:icon>
            <i class="bi bi-file-text text-custom fs-5 text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <!-- Clientes -->
      <li v-if="userRole === 'SuperAdmin'" class="nav-item">
        <sidenav-item
          to="/cliente-clientes"
          :class="getRoute() === 'cliente-clientes' ? 'active' : ''"
          :navText="'Clientes'"
        >
          <template v-slot:icon>
            <i class="bi bi-person text-custom fs-5 text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <!-- Notificaciones -->
      <li v-if="userRole === 'SuperAdmin' || userRole === 'Administrador' || userRole === 'Docente'" class="nav-item">
        <sidenav-item
          to="/cliente-notificaciones"
          :class="getRoute() === 'cliente-clientes' ? 'active' : ''"
          :navText="'Notificaciones'"
        >
          <template v-slot:icon>
            <i class="bi bi-bell text-custom fs-5 text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <!-- Cerrar Sesión -->
      <li class="nav-item mt-auto text-center">
        <div style="margin-top: 60%" >
          <a href="#" @click.prevent="showModal = true" class="btn btn-danger">
            <i class="bi bi-power fs-5 me-2"></i>
            Cerrar Sesión
          </a>
        </div>
      </li>
    </ul>
  </div>

  <!-- Modal -->
  <teleport to="body">
    <div v-if="showModal" class="modal-overlay">
      <div class="modal-box">
        <h5 class="mb-3">¿Estás seguro que deseas cerrar sesión?</h5>
        <div class="modal-buttons">
          <button class="btn btn-secondary" @click="showModal = false">Cancelar</button>
          <button class="btn btn-danger" @click="CerrarSesion">Aceptar</button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<style scoped>
.text-custom {
  color: #007bff;
}
.text-danger {
  color: #dc3545;
}

/* Modal estilos */
.modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}

.modal-box {
  background-color: #fff;
  border-radius: 12px;
  padding: 2rem;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
  text-align: center;
}

.modal-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  margin-top: 1.5rem;
}
</style>

